import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ELacProcessTypes } from 'src/app/domain/Lac - EAU/enum/lac-process-types';
import { MesurePhysique } from 'src/app/domain/Lac - EAU/mesure-physique';

@Component({
    selector: 'app-lac-measure-box',
    templateUrl: './lac-measure-box.component.html',
    styleUrls: ['./lac-measure-box.component.scss']
})
export class LacMeasureBoxComponent implements OnInit {
    public PROF_MAX = 150;
    public TEMP_MAX = 50;
    public PH_MAX = 14;
    public OXY_MAX = 40;
    public SAT_MAX = 200;
    ValidProfMax = new UntypedFormControl(0, [Validators.max(this.PROF_MAX), Validators.min(0)]);
    ValidTempMax = new UntypedFormControl(0, [Validators.max(this.TEMP_MAX), Validators.min(0)]);
    ValidPhMax = new UntypedFormControl(0, [Validators.max(this.PH_MAX), Validators.min(0)]);
    ValidOxygeneMax = new UntypedFormControl(0, [Validators.max(this.OXY_MAX), Validators.min(0)]);
    ValidSaturationMax = new UntypedFormControl(0, [Validators.max(this.SAT_MAX), Validators.min(0)]);
    public NewMeasure: MesurePhysique;
    HasOnlyIntegratedWater: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<LacMeasureBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {

        this.NewMeasure = data.measure ?? new MesurePhysique();

        if (this.Is(data.types, ELacProcessTypes.PrelEauIntegre) && !this.Is(data.types, ELacProcessTypes.PhysiqueChimieInSitu)) {
            this.NewMeasure.IsForEauIntegre = true;
            this.HasOnlyIntegratedWater = true;
        } else {
            this.NewMeasure.IsForEauIntegre = false;
        }
    }

    ngOnInit(): void {
        this.ValidProfMax.markAsTouched();
        this.ValidTempMax.markAsTouched();
        this.ValidPhMax.markAsTouched();
        this.ValidSaturationMax.markAsTouched();
        this.ValidOxygeneMax.markAsTouched();
    }

    Is(types: number, type: ELacProcessTypes) {
        return !!(types & type);
    }
    
    CanAddNewMeasure() {
        if (this.NewMeasure.IsForEauIntegre) {
            return (
                (this.NewMeasure.OxygeneDissous && this.ValidOxygeneMax.valid) ||
                (this.NewMeasure.Conductivite) ||
                (this.NewMeasure.SaturationO2d && this.ValidSaturationMax.valid) ||
                (this.NewMeasure.TemperatureBrute && this.ValidTempMax.valid) ||
                (this.NewMeasure.pH && this.ValidPhMax.valid));
        }
        return (this.NewMeasure.Profondeur && this.ValidProfMax.valid) && (
            (this.NewMeasure.OxygeneDissous && this.ValidOxygeneMax.valid) ||
            (this.NewMeasure.Conductivite) ||
            (this.NewMeasure.SaturationO2d && this.ValidSaturationMax.valid) ||
            (this.NewMeasure.TemperatureBrute && this.ValidTempMax.valid) ||
            (this.NewMeasure.pH && this.ValidPhMax.valid));
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.NewMeasure);
    }
}
